import { Paper, styled } from "@mui/material"
import { getSubtleSurfaceShadow } from "components/common/elevation"

const SurfacePaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: getSubtleSurfaceShadow(theme),
}))

export default SurfacePaper
